import axios from "axios";
import selectedBrand from "constants/brand";

import {
  BASE_URL,
  WARRANTY_BRANDS_ENDPOINT,
  ADD_BRAND_MODEL_WARRANTY_ENDPOINT,
  UPDATE_BRAND_MODEL_WARRANTY_ENDPOINT,
} from "constants/api-config-constants";
import {
  AddBrandModelWarrantyPayload,
  GetWarrantiesResponse,
  UpdateBrandModelWarrantyPayload,
} from "interfaces/warranty-interfaces";

interface GetBrandModelWarrantiesOptions {
  isDefaultBrand?: boolean;
}

export const getBrandModelWarranties = async (
  options?: GetBrandModelWarrantiesOptions
): Promise<GetWarrantiesResponse> => {
  let url =
    BASE_URL +
    WARRANTY_BRANDS_ENDPOINT +
    "/" +
    selectedBrand() +
    "/brandModels";
  if (options?.isDefaultBrand) {
    url += "?isDefault=true";
  }
  return axios.get(url);
};

export const addBrandModelWarranty = async (
  payload: AddBrandModelWarrantyPayload
) => {
  const url = BASE_URL + ADD_BRAND_MODEL_WARRANTY_ENDPOINT + "?brand=" + selectedBrand();
  return axios.post(url, payload);
};

export const updateBrandModelWarranty = async (
  id: number,
  payload: UpdateBrandModelWarrantyPayload
) => {
  const url = BASE_URL + UPDATE_BRAND_MODEL_WARRANTY_ENDPOINT + "/" + id;
  return axios.put(url, payload);
};

export const deleteBrandModelWarranty = async (id: number) => {
  const url = BASE_URL + UPDATE_BRAND_MODEL_WARRANTY_ENDPOINT + "/" + id;
  return axios.delete(url);
};
